import { container, Container } from "@components/wrapper"
import { StudentTestimonial } from "@interfaces/school"
import clsx from "clsx"
import React from "react"
import { BootcampHeading } from "../general/ProgramHeading"
import TestimonialRow from "../general/TestimonialRow"

export const BootcampTestimonial = ({
  testimonials,
  screenWidth,
}: {
  testimonials: StudentTestimonial[]
  screenWidth: number
}) => {

  if (!testimonials.length) {
    return <></>
  }

  return (
    <div className="bg-[#CADCFF] sm:py-20 py-10">
      <Container className="relative sm:mb-9 mb-6">
        <div className={clsx("relative sm-only:pb-4")}>
          <BootcampHeading
            id="testimonials"
            title="testimoni"
            subTitle="Apa Kata Alumni Harisenin.com?"
          />
        </div>
      </Container>

      <div className={clsx(screenWidth > 576 && container + 'mx-')}>
        <TestimonialRow screenWidth={screenWidth} testimonials={testimonials} />
      </div>
    </div>
  )
}
